import { reduce } from "et3-type-guards";
import getCorePopUpStore from "../../stores/core/core-popup-store";
import getUserAdvancedStore from "../../stores/user-store/advanced-store";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import { AlbumItem } from "./album-item";
import ET3Div from "../et3-div";
import React from "react";
import AlbumTitle from "./album-title";

const Album = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitY } = theme;
  const userID = getUserAdvancedStore().currentUserId.get();
  const pictures = reduce(
    () => getUserAdvancedStore().userData.get(userID).pictures,
    []
  );

  return getCorePopUpStore().isPicAlbumPopUpVisible.get() ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1500}
      height={500}
      fDirection="row"
      alignItems="flex-start"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        position: "absolute",
        top: 200,
        zIndex: 5
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={true}
        isExtendable={true}
        withShadow={true}
        width={1400}
        height={500}
        fDirection="column"
        alignItems="center"
        justifyContent="center"
        color={colors.all.lightGray}
        style={{
          borderRadius: 28,
          maxHeight: 700 * unitY
        }}
        onClick={() => {}}
      >
        <AlbumTitle />
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          withShadow={false}
          width={1400}
          height={500}
          fDirection="column"
          alignItems="center"
          justifyContent="center"
          color={colors.all.white}
          style={{}}
          onClick={() => {}}
        >
          <ET3Div
            isScrollable={true}
            isExtendable={true}
            withShadow={false}
            width={1200}
            height={500}
            fDirection="row"
            alignItems="center"
            justifyContent="center"
            color={colors.all.white}
            style={{
              flexWrap: "wrap"
            }}
            onClick={() => {}}
          >
            {pictures.map((picture, index) => {
              return (
                <React.Fragment>
                  <AlbumItem picture={picture} index={index} />
                </React.Fragment>
              );
            })}
          </ET3Div>
        </ET3Div>
      </ET3Div>
    </ET3Div>
  ) : null;
});
export default Album;
